import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap";

const CommitModal = ({ isOpen, toggle, nodeData }) => {
    const [name, setName] = useState("");

    const handleCommit = () => {
        console.log("Commiting with name:", name);
        const payload = {
            name: name,
            uuid: nodeData?.properties?.uuid,
        };
        // "/ronin/vm/commit/{uuid}/{_name}"
        axios
            .post(`/ronin/vm/commit/${payload.uuid}/${payload.name}`, {
                withCredentials: true,
            })
            .then((response) => {
                toast.success(`${response.data.message}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            })
            .catch((error) => {
                toast.error(`${error.response.data.message}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Commit</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="name">Name</Label>
                        <Input
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button className="stopBtn" onClick={toggle}>
                    Cancel
                </Button>
                <Button className="stopBtn" onClick={handleCommit}>
                    Commit
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default CommitModal;
